import { render, staticRenderFns } from "./alt-button.vue?vue&type=template&id=3a834d31&"
import script from "./alt-button.vue?vue&type=script&lang=ts&"
export * from "./alt-button.vue?vue&type=script&lang=ts&"
import style0 from "./alt-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports